import { getLessonProgressStatus } from "@memorang/ui/components/LessonsExploreScreen/helpers";
import type {
	ExploreLesson,
	LessonStatusFilter,
} from "@memorang/ui/components/LessonsExploreScreen/types";
import type { Lesson } from "@memorang/ui/components/LessonsHomeScreen/types";
import { exploreLessonDetails } from "./constants";

export const toExploreLessons = (lessons: Lesson[]): ExploreLesson[] =>
	lessons.map((lesson) => ({
		...lesson,
		progressPercent: exploreLessonDetails[lesson.id]?.progressPercent ?? 0,
	}));

export const lessonMatchesStatusFilter = (
	lesson: ExploreLesson,
	filter: LessonStatusFilter,
) =>
	filter === "all" ||
	getLessonProgressStatus(lesson.progressPercent) === filter;
